export default __webpack_public_path__ + "static/media/lighting_in_the_fog.10bb43d2.jpg";